import { render, staticRenderFns } from "./profile1c.vue?vue&type=template&id=5d5337a7&"
import script from "./profile1c.vue?vue&type=script&lang=js&"
export * from "./profile1c.vue?vue&type=script&lang=js&"
import style0 from "./profile1c.vue?vue&type=style&index=0&id=5d5337a7&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5337a7')) {
      api.createRecord('5d5337a7', component.options)
    } else {
      api.reload('5d5337a7', component.options)
    }
    module.hot.accept("./profile1c.vue?vue&type=template&id=5d5337a7&", function () {
      api.rerender('5d5337a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/modal/tabs/profile1c.vue"
export default component.exports